(() => {
  const HERO_SELECTOR = "main[data-template*='index'] .shopify-section[id$='__hero-main']";
  const BUTTON_CLASS = "nvb-next-section-button";
  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  function isVisible(element) {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== "none" && style.visibility !== "hidden" && rect.height > 0;
  }

  function findNextVisibleSection(heroSection) {
    let section = heroSection.nextElementSibling;

    while (section) {
      if (section.classList?.contains("shopify-section") && isVisible(section)) {
        return section;
      }

      section = section.nextElementSibling;
    }

    return null;
  }

  function createButton(heroSection) {
    const button = document.createElement("button");

    button.type = "button";
    button.setAttribute("data-action", "navigate-next");
    button.className = BUTTON_CLASS;
    button.setAttribute("aria-label", "Navigate to next section");
    button.innerHTML = `
      <span class="nvb-next-section-button__label">Navigate to next section</span>
      <svg aria-hidden="true" focusable="false" fill="none" width="18" class="icon icon-arrow-down" viewBox="0 0 18 16">
        <path d="m1 4 8 8 8-8" stroke="currentColor" stroke-linecap="square"></path>
      </svg>
    `;

    button.addEventListener("click", () => {
      const nextSection = findNextVisibleSection(heroSection);

      if (!nextSection) {
        return;
      }

      nextSection.scrollIntoView({
        behavior: window.matchMedia(REDUCED_MOTION_QUERY).matches ? "auto" : "smooth",
        block: "start",
      });
    });

    return button;
  }

  function mountNextSectionButton() {
    const heroSection = document.querySelector(HERO_SELECTOR);

    if (!heroSection || heroSection.querySelector(`.${BUTTON_CLASS}`)) {
      return;
    }

    heroSection.appendChild(createButton(heroSection));
  }

  document.addEventListener("DOMContentLoaded", mountNextSectionButton);
  document.addEventListener("shopify:section:load", mountNextSectionButton);

  if (document.readyState !== "loading") {
    mountNextSectionButton();
  }
})();
